module.exports = __webpack_public_path__ + "fonts/Zen_Maru_Gothic-700-410.3ce8d2c.woff2";